import clsx from "clsx";
import { createPortal } from "react-dom";
import { format } from "date-fns";
import React from "react";
import { ButtonComponent } from "../../../../ui/molecules/button/index.tsx";
import { CloseIcon } from "../../../../ui/icons/closeIcon.tsx";
import { AppointmentsDTO } from "../dto.ts";
import { DetailedListAppointment } from "../detailedListAppointment.tsx";
import { useAppDispatch } from "../../../../lib/redux/hook.ts";
import { setModalAppointmentType, findByIdAppointment, setNewAppointmentModal } from "../slice.ts";
import { NewAppointmentModal } from "../newAppointmentModal.tsx";

type Props = {
    visible: boolean
    appointments: AppointmentsDTO[]
    setVisibile: (visible: boolean) => void
    cleanAppointments: () => void
}
export function ModalDetailsList(props: Props) {
    const { visible, setVisibile, appointments, cleanAppointments } = props

    const dispatch = useAppDispatch()

    return createPortal(
        <div
            onClick={() => {
                setVisibile(false)
                cleanAppointments()
            }}
            className={clsx(
                "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
                {
                    block: visible,
                    hidden: !visible
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                className="transition-all flex flex-col opacity-100 rounded-xl bg-white shadow-sm max-w-[35%]"
            >
                <div className="border-b flex items-center justify-between h-16 border-b-neutral-200 w-full px-6">
                    {visible && <span className="text-heading-sm font-semibold text-neutral-800">Eventi del {format(new Date(appointments[0].startDate), 'dd/MM/yyyy')}</span>}
                    <ButtonComponent onClick={() => { setVisibile(false); cleanAppointments() }} size={"sm"} iconPosition={"only"} variant={"link"} color={"blue"} icon={<CloseIcon color={""} size={"0"} />} />
                </div>
                <div className="px-6 py-8 flex flex-col gap-4 max-h-[50vh] overflow-y-auto">
                    {appointments?.map(appointment => <DetailedListAppointment onClick={() => {
                        dispatch(setNewAppointmentModal(true))
                        dispatch(setModalAppointmentType("edit"));
                        dispatch(findByIdAppointment(appointment.id));
                        dispatch(setNewAppointmentModal(true));
                    }} appointment={appointment} />)}
                </div>
            </div>
            <NewAppointmentModal />
        </div >
        , document.body)
}